/**
 * Admin user management — promotes bridge-provisioned Viewers to Accountant
 * (the "Viewer-trap" fix; roles: admin | senior_accountant | accountant | viewer).
 */
import { api } from './client';

export interface UserDto {
  id: number;
  username: string;
  role: string;
  isActive: boolean;
  isBridged: boolean;
  createdAt: string;
  lastLoginAt: string | null;
}

export const usersApi = {
  list: () => api.get<UserDto[]>('/users'),
  setRole: (id: number, role: string) => api.put<UserDto>(`/users/${id}/role`, { role }),
};
